import ZipBanner from './ZipBanner'
import ZipNeed from './ZipNeed'
import { lazy, Suspense } from 'react'

const ZipBusiness = lazy(() => import('./ZipBusiness'));
const ZipFeature = lazy(() => import('./ZipFeature'));
const ZipOffer = lazy(() => import('./ZipOffer'));
const ZipValue = lazy(() => import('./ZipValue'));
const ShuttleAppreciation = lazy(() => import('../../shuttle_software/ShuttleAppreciation'));
const TaxiFaq = lazy(() => import('../../taxiDispatchSoftware/TaxiFaq'));

const faqData = [
  {
    id: "0",
    question: "01. What is the Zipcar Clone App?",
    answer: "A Zipcar Clone App is a ready-made, customizable car-sharing solution that mimics the core functionalities of Zipcar—allowing users to book, unlock, and return vehicles on demand. It’s ideal for businesses or startups aiming to launch a self-service car rental or corporate fleet sharing platform.",
  },
  {
    id: "1",
    question: "02. What features are included in the Zipcar clone app?",
    answer: "A Zipcar clone typically includes real-time vehicle tracking, keyless car access, dynamic pricing, reservation scheduling, in-app payments, document verification, and admin dashboards. Users can find, book, and unlock cars through the app, while admins manage fleets, monitor usage, and optimize operations efficiently.",
  },
  {
    id: "2",
    question: "03. How can I ensure the security of user data?",
    answer: "Implement robust encryption protocols (SSL, AES), secure cloud hosting, multi-factor authentication, and regular security audits. Mobility Infotech integrates end-to-end security measures to keep user data safe and compliant with international standards.",
  },
  {
    id: "3",
    question: "04. How much does it cost to develop a Zipcar clone app?",
    answer: " The development cost of a Zipcar clone app can range from $15,000 to $60,000+, depending on features, platform (ios, Android, or both), backend architecture, and whether it’s custom-built or based on a white-label solution.",
  },
  {
    id: "4",
    question: "05. Do you offer white-label solutions?",
    answer: "Yes, we offer fully white-labeled Zipcar clone apps that can be tailored to reflect your brand’s identity, including logos, color schemes, and features, ensuring a personalized experience for your users.",
  },
  {
    id: "5",
    question: "06. Do you provide post-launch support?",
    answer: "Absolutely. We provide comprehensive post-launch support, including bug fixes, performance monitoring, feature upgrades, and technical assistance to ensure your Zipcar clone app runs smoothly after deployment.",
  }
];

export default function ZipcarClone() {
  return (
    <>
      <ZipBanner />
      <ZipNeed />

      <Suspense fallback={null}>
        <ZipOffer />
        <ZipFeature />
        <ZipValue />
        <ZipBusiness />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
